import { createContext } from 'react';

import { IndicatorData } from '../../core/components/annotations/components/indicators/types.js';

export const HistogramAnnotationsDataContext = createContext<{
  indicators: IndicatorData[][];
}>({ indicators: [] });

HistogramAnnotationsDataContext['displayName'] =
  'HistogramAnnotationsDataContext';
